import React, {Component} from 'react'
import ExportModal from './ExportModal'
import PropTypes from "prop-types"

class Export extends Component{
    state = {
        isOpen: false
    }

    _handleToggleModal = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    render() {
        const {isOpen} = this.state
        const {exporting, filter} = this.props

        return <div>
            <button className="btn btn-primary ml-3" onClick={this._handleToggleModal}>
                {exporting && <i className="fa fa-spinner fa-spin"/>} {exporting ? 'Exporting' : 'Export'}
            </button>
            {isOpen && <ExportModal isOpen={isOpen} onToggleModal={this._handleToggleModal} filter={filter}/>}
        </div>
    }
}

Export.propTypes = {
    filter: PropTypes.object.isRequired,
}

export default Export